'use client';
const noop = () => {
};

export { noop };
//# sourceMappingURL=noop.mjs.map
